<div class="manage">
  <h2>纪念人管理</h2>
  <div class="manage-container">
    <div class="search-bar">
      <input 
        type="text" 
        v-model="searchQuery" 
        @input="handleSearch"
        placeholder="请输入纪念人姓名搜索"
        class="search-input"
      />
    </div>
    
    <div class="table-container">
      <div v-if="loading" class="loading-wrapper">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>
      
      <table v-else class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>姓名</th>
            <th>头像</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="personList.length === 0">
            <td colspan="5" class="empty-text">暂无数据</td>
          </tr>
          <tr v-else v-for="item in personList" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>
              <img 
                v-if="item.avatar_url" 
                :src="item.avatar_url" 
                class="avatar-img" 
                alt="头像"
              />
              <span v-else>暂无头像</span>
            </td>
            <td>{{ item.created_at }}</td>
            <td class="action-column">
              <button 
                class="action-btn edit-btn"
                @click="handleEdit(item)"
              >
                编辑
              </button>
              <button 
                class="action-btn delete-btn"
                @click="handleDelete(item)"
              >
                删除
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div v-if="personList.length > 0" class="pagination">
        <button 
          :disabled="currentPage === 1" 
          @click="handlePageChange(currentPage - 1)"
          class="page-btn"
        >
          上一页
        </button>
        <span class="page-info">
          第 {{ currentPage }} 页 / 共 {{ totalPages }} 页
        </span>
        <button 
          :disabled="currentPage === totalPages" 
          @click="handlePageChange(currentPage + 1)"
          class="page-btn"
        >
          下一页
        </button>
      </div>
    </div>
  </div>
</div> 